/* eslint-disable no-restricted-globals */
import { Link, Navigate, useNavigate } from "react-router-dom";
import AuthForm from "../../components/authForm/authForm";
import InputField from "../../components/inputField/inputField";
import PrimaryBtn from "../../components/primaryButton/primaryBtn";
import { useContext, useEffect, useState } from "react";
import { LOGIN_URL } from "../../global/API";
import { AuthContext } from "../../context/AuthContext/AuthContext";
import Cookies from "js-cookie";

const SignIn = (props) => {
  const { setIsActive } = props;
  const [userDetails, setUserDetails] = useState({ email: "", password: "" });
  const [errorMsg, setErrorMsg] = useState({ emailError: "", passwordError: "", formError: "" });
  const [showPassword, setShowPassword] = useState(false);
  // const { setUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const getUserEmail = (event) => {
    setUserDetails({ ...userDetails, email: event.target.value });
    setErrorMsg({ ...errorMsg, emailError: "" });
  };

  const getUserPassword = (event) => {
    setUserDetails({ ...userDetails, password: event.target.value });
    setErrorMsg({ ...errorMsg, passwordError: "" });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const formElement = document.getElementById("authLogin");
    const formData = new FormData(formElement);
    const options = {
      method: "POST",
      body: formData,
    };
    const response = await fetch(LOGIN_URL, options);
    const data = await response.json();

    if (data.status === "Success") {
      Cookies.set("jwtToken", data.token, { expires: 7 });
      // setUser(data.user);
      // ✅ store user data & phone in localStorage
      // localStorage.setItem("userData", JSON.stringify(data.user));
      navigate("/properties", { replace: true });
    }
    if (data.status === "Error") {
      setErrorMsg({
        emailError: data.message.email !== undefined ? data.message.email[0] : "",
        passwordError: data.message.password !== undefined ? data.message.password[0] : "",
        formError: data.message.email === undefined && data.message.password === undefined ? data.message : "",
      });
    }
  };

  const signForm = () => {
    return (
      <div className="px-4">
        <form className="authentication-form" id="authLogin">
          <div className="mb-3">
            <label className="form-label">Email</label>
            <InputField name="email" type="email" placeholder="Enter your email" onChange={getUserEmail} value={userDetails.email} />
            {errorMsg.emailError !== "" && <p className="error-msg">{errorMsg.emailError}</p>}
          </div>
          <div className="mb-3">
            {/* <a href="auth-password.html" className="float-end text-muted text-unline-dashed ms-1">
              Reset password
            </a> */}
            <label className="form-label">Password</label>
            <div className="selected-input">
              <InputField name="password" placeholder="Enter your password" type={showPassword ? "text" : "password"} onChange={getUserPassword} value={userDetails.password} />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className={showPassword ? "ri-eye-line" : "ri-eye-off-line"}></button>
            </div>
            {errorMsg.passwordError !== "" && <p className="error-msg">{errorMsg.passwordError}</p>}
          </div>
          <div className="mb-3">
            <div className="form-check">
              <input type="checkbox" className="form-check-input" id="checkbox-signin" />
              <label className="form-check-label" htmlFor="checkbox-signin">
                Remember me
              </label>
            </div>
          </div>

          <div className="mb-1 text-center d-grid">
            <PrimaryBtn type="submit" submitBtn={onSubmit}>
              Sign In
            </PrimaryBtn>
            {errorMsg.formError !== "" && <p className="error-msg">{errorMsg.formError}</p>}
          </div>
        </form>

        {/* <p className="mt-3 fw-semibold no-span">OR sign with</p>

        <div className="text-center">
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="bx bxl-google fs-20"></i>
          </a>
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="ri-facebook-fill fs-20"></i>
          </a>
          <a href="javascript:void(0);" className="btn btn-outline-light shadow-none">
            <i className="bx bxl-github fs-20"></i>
          </a>
        </div> */}
      </div>
    );
  };
  useEffect(() => {
    setIsActive(false);
    return () => {
      setIsActive(true);
    };
  }, []);

  const jwtToken = Cookies.get("jwtToken");
  if (jwtToken !== undefined) {
    return <Navigate to="/" replace />;
  } else {
    return (
      <section className="authentication-bg">
        <div className="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-5">
                <AuthForm title="Sign In" subtitle="Enter your email address and password to access admin panel." form={signForm} />
                <p className="mb-0 text-center text-white">
                  New here?
                  <Link to="/signup" className="text-reset text-unline-dashed fw-bold ms-1">
                    Sign Up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default SignIn;
